module.exports = __webpack_public_path__ + "img/burger.be5030ca.webp";